import { CLEAR_OFFER_COMMISSION_DATA } from './apiActionConstants'
import type { AppAction } from './types/ActionTypes'

export const clearOfferCommissionData = (offerId: string): AppAction => {
  return {
    type: CLEAR_OFFER_COMMISSION_DATA,
    key: offerId,
  }
}
